"use strict";

(function () {
  const adpPopup = {
    sPrevious: window.scrollY,
    sDirection: "down",
    eventsBound: false,
    scrollTrackerBound: false,

    init: function () {
      adpPopup.events();
      adpPopup.popupInit();
    },

    events: function () {
      if (adpPopup.eventsBound) return;
      adpPopup.eventsBound = true;

      document.addEventListener("click", function (e) {
        document.querySelectorAll('.popup[data-open-trigger="manual"]').forEach(function (popup) {
          const selector = popup.dataset.openManualSelector;
          if (!selector || !e.target.closest(selector)) return;
          e.preventDefault();
          popup.classList.remove("popup-already-opened");
          adpPopup.openPopup(popup);
        });

        if (e.target.closest(".popup-close")) {
          adpPopup.acceptPopup(e);
          adpPopup.closePopup(e);
        }
        if (e.target.closest(".popup-accept")) {
          adpPopup.acceptPopup(e);
          adpPopup.closePopup(e);
        }
        if (e.target.closest(".age-verification__popup-close")) {
          adpPopup.agePopup(e);
          adpPopup.closePopup(e);
        }
        if (e.target.closest(".age-verification__button-no")) {
          adpPopup.ageDeclined();
        }
        if (e.target.closest(".popup-overlay")) {
          document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(popup => {
            adpPopup.closePopup(popup);
          });
        }
      });

      document.addEventListener("keyup", function (e) {
        if (e.key === "Escape") {
          document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(popup => {
            adpPopup.closePopup(popup);
          });
        }
        if (e.key === "F4") {
          document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(popup => {
            adpPopup.closePopup(popup);
          });
        }
      });

      document.addEventListener("scroll", function () {
        const scrollCurrent = window.scrollY;
        adpPopup.sDirection = scrollCurrent > adpPopup.sPrevious ? "down" : "up";
        adpPopup.sPrevious = scrollCurrent;
        adpPopup.handleScrollPopupTriggers();
      });

      document.addEventListener("mousemove", function (e) {
        adpPopup.handleExitPopupTriggers(e);
      });
    },

    popupInit: function () {
      document.querySelectorAll(".popup").forEach(function (popup) {
        if (popup.dataset.openTrigger === "manual") {
          const selector = popup.dataset.openManualSelector;
          if (selector) {
            document.querySelectorAll(selector).forEach(el => el.classList.add("popup-trigger"));
          }
        }

        if (!adpPopup.isAllowPopup(popup) && !popup.classList.contains("age-verification")) {
          return;
        }

        adpPopup.openTriggerPopup(popup);
      });
    },

    handleExitPopupTriggers: function (e) {
      document.querySelectorAll('.popup[data-open-trigger="exit"]').forEach(function (popup) {
        if (popup.dataset.exitTriggerHandled === "true") return;
        if (!adpPopup.isAllowPopup(popup) && !popup.classList.contains("age-verification")) return;
        const scroll = window.scrollY || document.documentElement.scrollTop;
        if (e.pageY - scroll < 7) {
          popup.dataset.exitTriggerHandled = "true";
          adpPopup.openPopup(popup);
        }
      });
    },

    handleScrollPopupTriggers: function () {
      document.querySelectorAll('.popup[data-open-trigger="scroll"]').forEach(function (popup) {
        if (!adpPopup.isAllowPopup(popup) && !popup.classList.contains("age-verification")) return;
        const pointScrollType = popup.dataset.openScrollType;
        const pointScrollPosition = parseFloat(popup.dataset.openScrollPosition);
        if (pointScrollType === "px" && window.scrollY >= pointScrollPosition) {
          adpPopup.openPopup(popup);
        }
        if (pointScrollType === "%" && adpPopup.getScrollPercent() >= pointScrollPosition) {
          adpPopup.openPopup(popup);
        }
      });

      document.querySelectorAll('.popup.popup-open[data-close-trigger="scroll"]').forEach(function (popup) {
        const pointScrollType = popup.dataset.closeScrollType;
        const pointScrollPosition = parseFloat(popup.dataset.closeScrollPosition);
        const initScrollPx = parseFloat(popup.dataset.initScrollPx || 0);
        const initScrollPercent = parseFloat(popup.dataset.initScrollPercent || 0);

        if (pointScrollType === "px") {
          if (adpPopup.sDirection === "up" && window.scrollY < initScrollPx - pointScrollPosition) {
            adpPopup.closePopup(popup);
          }
          if (adpPopup.sDirection === "down" && window.scrollY >= initScrollPx + pointScrollPosition) {
            adpPopup.closePopup(popup);
          }
        }
        if (pointScrollType === "%") {
          const pct = adpPopup.getScrollPercent();
          if (adpPopup.sDirection === "up" && pct < initScrollPercent - pointScrollPosition) {
            adpPopup.closePopup(popup);
          }
          if (adpPopup.sDirection === "down" && pct >= initScrollPercent + pointScrollPosition) {
            adpPopup.closePopup(popup);
          }
        }
      });
    },

    openTriggerPopup: function (popup) {
      if (popup.dataset.openTriggerBound === "true") return;
      popup.dataset.openTriggerBound = "true";

      const trigger = popup.dataset.openTrigger;

      if (trigger === "none") {
        const ageVerification = adpPopup.getStorage("popup-age-" + (popup.dataset.id || 0));
        if (!ageVerification) adpPopup.openPopup(popup);
      }

      if (trigger === "delay") {
        setTimeout(function () {
          adpPopup.openPopup(popup);
        }, (popup.dataset.openDelayNumber || 0) * 1000);
      }

      if (trigger === "accept") {
        const accept = adpPopup.getStorage("popup-accept-" + (popup.dataset.id || 0));
        if (!accept) adpPopup.openPopup(popup);
      }
    },

    closeTriggerPopup: function (popup) {
      const trigger = popup.dataset.closeTrigger;

      if (trigger === "delay") {
        setTimeout(function () {
          adpPopup.closePopup(popup);
        }, (popup.dataset.closeDelayNumber || 0) * 1000);
      }
    },

    openPopup: function (popup) {
      if (!popup || typeof popup.classList === "undefined") return;
      if (popup.classList.contains("popup-open")) return;
      if (popup.classList.contains("popup-already-opened")) return;

      if (popup.dataset.bodyScrollDisable === "true") {
        document.body.classList.add("popup-scroll-hidden");
      }

      const id = popup.dataset.id || 0;
      const limit = parseInt(adpPopup.getStorage("popup-" + id) || 0) + 1;
      adpPopup.setStorage("popup-" + id, limit, { expires: popup.dataset.limitLifetime });

      popup.classList.add("popup-open");
      popup.dataset.initScrollPx = window.scrollY;
      popup.dataset.initScrollPercent = adpPopup.getScrollPercent();

      adpPopup.applyAnimation(popup, popup.dataset.openAnimation);
      adpPopup.closeTriggerPopup(popup);
    },

    agePopup: function (e) {
      const el = e.target ? e.target.closest(".age-verification__popup-close") : e;
      if (!el) return;
      const popup = el.closest(".popup");
      if (!popup) return;
      adpPopup.setStorage("popup-age-" + (popup.dataset.id || 0), 1, { expires: 360 });
      try { sessionStorage.setItem('eupoupo_age_verified', 'true'); } catch(err) {}
    },

    ageDeclined: function () {
      document.querySelectorAll(".age-verification__question").forEach(el => el.classList.remove("show"));
      document.querySelectorAll(".age-verification__declined").forEach(el => el.classList.add("show"));
    },

    acceptPopup: function (e) {
      const el = e.target ? e.target.closest(".popup-accept, .popup-close") : e;
      if (!el) return;
      const popup = el.closest(".popup");
      if (!popup) return;
      adpPopup.setStorage("popup-accept-" + (popup.dataset.id || 0), 1, { expires: 360 });
    },

    closePopup: function (e) {
      let popup;
      if (e && e.target) {
        const el = e.target.closest(".popup-close, .age-verification__popup-close");
        popup = el ? el.closest(".popup") : null;
      } else {
        popup = e && e.classList ? e : null;
      }
      if (!popup) return;

      adpPopup.applyAnimation(popup, popup.dataset.exitAnimation, function () {
        popup.classList.add("popup-already-opened");
        popup.classList.remove("popup-open");
        document.body.classList.remove("popup-scroll-hidden");
      });
    },

    isAllowPopup: function (popup) {
      const limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
      const limitDisplayCookie = parseInt(adpPopup.getStorage("popup-" + (popup.dataset.id || 0)));
      if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) return false;
      return true;
    },

    applyAnimation: function (el, name, callback) {
      const popup = el.closest ? el.closest(".popup") : el;
      if (!popup) return;

      const overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

      const overlay = popup.nextElementSibling;
      if (overlay && overlay.classList.contains("popup-overlay")) {
        overlay.classList.add("popup-animated", overlayName);
        overlay.addEventListener("animationend", function handler() {
          overlay.classList.remove("popup-animated", overlayName);
          overlay.removeEventListener("animationend", handler);
        });
      }

      const wrap = popup.querySelector(".popup-wrap");
      if (wrap) {
        wrap.classList.add("popup-animated", name);
        wrap.addEventListener("animationend", function handler() {
          wrap.classList.remove("popup-animated", name);
          wrap.removeEventListener("animationend", handler);
          if (typeof callback === "function") callback();
        });
      }
    },

    getCookie: function (name) {
      const matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    getStorage: function (key) {
      const item = localStorage.getItem(key);
      if (item) {
        try {
          const parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch {
          return undefined;
        }
      }
      const cookieValue = adpPopup.getCookie(key);
      if (cookieValue !== undefined) {
        adpPopup.setStorage(key, cookieValue);
        return cookieValue;
      }
      return undefined;
    },

    setStorage: function (key, value, options = {}) {
      const data = { value, expires: null };
      if (options.expires) {
        const expiresDate = new Date();
        expiresDate.setDate(expiresDate.getDate() + parseInt(options.expires, 10));
        data.expires = expiresDate.getTime();
      }
      localStorage.setItem(key, JSON.stringify(data));
    },

    getScrollPercent: function () {
      const h = document.documentElement;
      const b = document.body;
      return ((h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) * 100;
    },
  };

  adpPopup.init();

  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });

  document.addEventListener("shopify:section:unload", function () {
    document.body.classList.remove("popup-scroll-hidden");
  });
})();
